import { gql } from '@apollo/client';

export const ON_NEW_NOTIFICATION = gql`
  subscription NewNotification {
    newNotification {
      id
      type
      message
      read
      createdAt
      additionalData {
        __typename
        ... on PaymentDeadlineNotificationData {
          ownerUserId
          rentCharge {
            id
            amountValue
            description
            dueDate
            executionDate
            rentChargeStatusOption
            rentChargeTypeOption
            currencyOption
          }
        }
        ... on IncidentCreatedNotificationData {
          incidentId
          tenantName
          propertyName
        }
        ... on IncidentAssignedNotificationData {
          incidentId
          incidentSubject
          propertyName
        }
        ... on IncidentReportSubmittedNotificationData {
          incidentId
          incidentReportId
          incidentSubject
          supplierName
        }
        ... on IncidentFollowUpNotificationData {
          incidentId
          incidentSubject
          propertyName
          daysSinceCreation
        }
        ... on MessageCreatedNotificationData {
          messageId
          senderName
          incidentId
        }
        ... on ContractNotificationData {
          contractId
        }
      }
    }
  }
`

